<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="first-section">
        <h5 class="table-title">Items On Hands</h5>
      </div>
      <div
        class="second-section d-flex align-items-center justify-content-end"
        id="customDrpdown"
      >
        <span matTooltip="Export Data" matTooltipPosition="above">
          <button
            class="btn filter-btn"
            (click)="exportToExcel()"
            [disabled]="exporting"
          >
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/export.svg"
            />
          </button>
        </span>
        <span matTooltip="Select Column(s)" matTooltipPosition="above">
          <div class="dropdown ms-2">
            <button
              class="btn filter-btn dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                style="width: 22px"
                src="../../../assets/Pricingscreen/sort.svg"
                class="svg-icon"
              />
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
              appOutsideClick
            >
              <h6>Dimension Display</h6>
              <div
                class="sort-row"
                *ngFor="let col of arrayForsort; index as i"
              >
                <input
                  type="checkbox"
                  class="form-check-input dept"
                  id="dept{{ i }}"
                  (click)="showhide(i)"
                  [checked]="col.value"
                />
                <label for="dept{{ i }}">{{ col.key }}</label>
              </div>
            </div>
          </div>
        </span>

        <span matTooltip="Filter Data" matTooltipPosition="above">
          <button
            class="btn filter-btn ms-2"
            data-bs-target="#filterData"
            data-bs-toggle="modal"
            (click)="openFilterModal('Open')"
          >
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/filter.svg"
            />
          </button>
        </span>
        <div class="searchbar d-flex ms-2">
          <img class="search me-2" src="../../../assets/icons/searchbar.svg" />
          <input
            type="text"
            placeholder="Search"
            [(ngModel)]="invData"
            (keyup)="getSearchResult($event)"
          />
        </div>
      </div>
    </div>
  </div>

  <section class="intro">
    <div class="table-container">
      <table class="table category-table table-condensed">
        <thead class="main-head sticky-top">
          <tr>
            <th
              scope="col"
              class="text-trasnform"
              style="align-items: center"
              [hidden]="!showDept"
            >
              <label for="flexCheckDefault" class="ms-2">Department</label>
              <i
                class="fa-regular fa-circle-xmark text-danger ms-1"
                (click)="clearFilter('Department')"
                *ngIf="filterDepartmentIDs.length > 0"
              ></i>
            </th>
            <th scope="col" class="text-trasnform" [hidden]="!showCtg">
              Category
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter('Category')"
                *ngIf="filterCategoriesIDs.length > 0"
              ></i>
            </th>
            <th scope="col" class="text-trasnform" [hidden]="!showColor || !showWeekColor">
              Week Color
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter('Color')"
                *ngIf="filterColorIDs.length > 0"
              ></i>
            </th>
            <th scope="col" class="text-trasnform" [hidden]="!showStore">
             Produced At Store
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter('Store')"
                *ngIf="filterStoreIDs.length > 0"
              ></i>
            </th>
            <th scope="col" class="text-trasnform" [hidden]="!showLocation">
            Produced At Location
              <i
                class="fa-regular fa-circle-xmark text-danger"
                (click)="clearFilter('Location')"
                *ngIf="filterLocationIDs.length > 0"
              ></i>
            </th>
            <th
              scope="col"
              class="text-trasnform"
              class="text-end"
              [hidden]="!showInventory"
            >
              On Hand
            </th>
            <th
              scope="col"
              class="text-trasnform"
              class="text-end"
              [hidden]="!showCostPrice"
            >
              Cost Price
            </th>
            <th
              scope="col"
              class="text-trasnform"
              style="text-align: end; padding-right: 1rem"
              [hidden]="!showCostAmt"
            >
              Total Value
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Deptpriceconfigarray">
            <td [hidden]="!showDept">
              <div class="d-flex align-items-center" [hidden]="!showDept">
                <span style="font-size: 14px; font-weight: 700">{{
                  item.departmentDescr
                }}</span>
              </div>
            </td>
            <td [hidden]="!showCtg">
              <div class="d-flex align-items-center">
                <span>{{ item.categoryName }}</span>
              </div>
            </td>
            <td [hidden]="!showColor || !showWeekColor">
              <div class="d-flex align-items-center">
                <span
                  [style.backgroundColor]="item.color"
                  style="
                    border-radius: 25px;
                    text-align: center;
                    height: 29px;
                    border: 1px solid #d8d8d8;
                    width: 98px;
                  "
                >
                  {{ item.displayName }}
                </span>
              </div>
            </td>
            <td [hidden]="!showStore">{{ item.storeName }}</td>
            <td [hidden]="!showLocation">{{ item.locationTypeDesc }}</td>
            <td [hidden]="!showInventory" style="text-align: end">
              {{ item.qty }}
            </td>
            <td [hidden]="!showCostPrice" style="text-align: end">
              {{ item.price | currency }}
            </td>
            <td
              [hidden]="!showCostAmt"
              style="text-align: end; padding-right: 1rem"
            >
              {{ item.totalPrice | currency }}
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="loading" class="text-center my-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div
        *ngIf="Deptpriceconfigarray?.length == 0"
        class="nodata"
        style="
          height: 56vh;
          width: 100%;
          display: flex;
          margin: auto;
          align-items: center;
          margin: auto;
          border: none;
        "
      >
        <p
          style="
            margin: auto;
            border: transparent !important;
            font-size: 2rem;
            color: #a4a4a4;
          "
        >
          No Data Available
        </p>
      </div>
      <div #anchor style="height: 1px"></div>
    </div>
  </section>
</div>

<!--Boostrap modal for filter data-->
<div
  class="modal fade"
  id="filterData"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="mb-0">Filters</h5>
      </div>
      <div class="modal-body p-0">
        <div class="filter d-flex">
          <div class="filter-labels">
            <h6 class="ps-4">Lists</h6>
            <div class="filter-labels-wrapper">
              <ul class="list-unstyled">
                <li
                  (click)="selectedFilterCategory('Department')"
                  [ngClass]="{ active: filterName === 'Department' }"
                >
                  Department
                  <br />
                  <p *ngIf="filterDepartmentIDs.length > 0">
                    {{ filterDepartmentIDs.length }} selected
                  </p>
                </li>

                <li
                  (click)="selectedFilterCategory('Category')"
                  [ngClass]="{ active: filterName === 'Category' }"
                >
                  Category
                  <br />
                  <p *ngIf="filterCategoriesIDs.length > 0">
                    {{ filterCategoriesIDs.length }} selected
                  </p>
                </li>

                <li
                  (click)="selectedFilterCategory('Color')"
                  [ngClass]="{ active: filterName === 'Color' }"
                  *ngIf="showWeekColor"
                >
                  Color
                  <br />
                  <p *ngIf="filterColorIDs.length > 0">
                    {{ filterColorIDs.length }} selected
                  </p>
                </li>

                <li
                  (click)="selectedFilterCategory('Store')"
                  [ngClass]="{ active: filterName === 'Store' }"
                >
                  Store
                  <br />
                  <p *ngIf="filterStoreIDs.length > 0">
                    {{ filterStoreIDs.length }} selected
                  </p>
                </li>

                <!--
    <li
      (click)="selectedFilterCategory('Location')"
      [ngClass]="{ 'active': filterName === 'Location' }"
    >
      Location
      <br />
      <p *ngIf="filterLocationIDs.length > 0">
        {{ filterLocationIDs.length }} selected
      </p>
    </li>
    -->
              </ul>
            </div>
          </div>
          <div class="filter-data">
            <h6 class="ps-2">Selected by: {{ filterName }}</h6>
            <div class="filter-data-wrapper">
              <div class="row" *ngIf="filterName == 'Department'">
                <div
                  class="col-lg-4 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforFilters;
                    let idx = index
                  "
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                    (click)="
                      collectFilterParameters(
                        data.departmentId,
                        'DeptpriceconfigarrayforFilters',
                        'departmentId',
                        filterDepartmentIDs
                      )
                    "
                  >
                    <i><img class="filtericon" [src]="data.imageIcon" /></i>
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black; text-wrap: nowrap"
                      >{{ data.departmentDescr }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Category'">
                <div
                  class="col-lg-4 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforCategory;
                    let idx = index
                  "
                  (click)="
                    collectFilterParameters(
                      data.categoryId,
                      'DeptpriceconfigarrayforCategory',
                      'categoryId',
                      filterCategoriesIDs
                    )
                  "
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                  >
                    <i><img class="filtericon" [src]="data.imageIcon" /></i>
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black; text-wrap: nowrap"
                    >
                      {{ data.categoryName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Color' && showWeekColor">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforColor;
                    let idx = index
                  "
                  (click)="
                    collectFilterParameters(
                      data.id,
                      'DeptpriceconfigarrayforColor',
                      'productionCycleId',
                      filterColorIDs
                    )
                  "
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                    [style.BackgroundColor]="data.color"
                  >
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                    >
                      {{ data.displayName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Store'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforStore;
                    let idx = index
                  "
                  (click)="
                    collectFilterParameters(
                      data.storeId,
                      'DeptpriceconfigarrayforStore',
                      'storeId',
                      filterStoreIDs
                    )
                  "
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                  >
                    <span
                      class="mt-2 text-center"
                      style="font-size: 13px; color: black"
                    >
                      {{ data.storeName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="filterName == 'Location'">
                <div
                  class="col-lg-3 col-sm-6"
                  *ngFor="
                    let data of DeptpriceconfigarrayforLocation;
                    let idx = index
                  "
                  (click)="
                    collectFilterParameters(
                      data.id,
                      'DeptpriceconfigarrayforLocation',
                      'id',
                      filterLocationIDs
                    )
                  "
                >
                  <div
                    class="conntent-box"
                    [ngClass]="{ active: data.isSelected == true }"
                  >
                    <span class="mt-2" style="font-size: 13px; color: black">
                      {{ data.name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <div class="footer-wrapper">
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: #ffffff; color: rgb(23, 95, 145)"
            (click)="openFilterModal('Close')"
          >
            Cancel
          </button>
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            style="background-color: rgb(23, 95, 145); color: white"
            (click)="getFilterData()"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
